// @flow

import React from 'react';

import Accordion from 'client/components/accordion/accordion';
import Panel from 'client/components/accordion/panel';

type Props = {
  faq: string,
};

const FaqSection = ({ faq }: Props) => (
  <div className="flex-row center-col-xlarge">
    <div className="large-5 show-for-large pad-right-3">
      <img
        loading="lazy"
        src="https://images.ctfassets.net/heg7gyzix6dq/1urXMlZfrbh9tVWbY1bKRG/d00d90cb21883f025e00927df977ee9f/Hetal_health_coverage_mobile.png"
        alt="Support" />
    </div>
    <div className="large-7 medium-12">
      <Accordion className="accordion-wrapper">
        {JSON.parse(faq).map(item => (
          <Panel key={item.name} title={<span>{item.question}</span>}>
            <div dangerouslySetInnerHTML={{ __html: `${item.answer}` }} />
          </Panel>
        ))}
      </Accordion>
    </div>
  </div>
);

export default FaqSection;
